import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { createContext, useContext } from "react";
// import { AuthContext } from "../contexts/AuthContext";

export default function useBreakpoints() {
  const theme = useTheme();

  const breakpoints = {
    isSm: useMediaQuery(theme.breakpoints.up("xs")),
    isMd: useMediaQuery(theme.breakpoints.up("sm")),
    isLg: useMediaQuery(theme.breakpoints.up("md")),
    isXl: useMediaQuery(theme.breakpoints.up("lg")),
    active: "md",
  };

  if (breakpoints.isSm) breakpoints.active = "sm";
  if (breakpoints.isMd) breakpoints.active = "md";
  if (breakpoints.isLg) breakpoints.active = "lg";
  if (breakpoints.isXl) breakpoints.active = "xl";
  const breakpoint = breakpoints.active;
  const isSmall = breakpoints.active === "sm" || breakpoints.active === "md";
  const isMedium = breakpoints.active === "md";
  const isMobile = breakpoints.active === "sm";

  return { breakpoint, isSmall, isMedium, isMobile };
}
